import { useEffect } from "react";

/**
 * TrackingScripts
 * Reads tracking IDs from .env (REACT_APP_META_PIXEL_ID, REACT_APP_GOOGLE_ADS_ID)
 * and injects Meta Pixel + Google Ads scripts only if the IDs are set.
 * Exposes window.bcTrack(eventName, params) for custom conversions.
 */
export default function TrackingScripts() {
  const metaId = process.env.REACT_APP_META_PIXEL_ID;
  const googleId = process.env.REACT_APP_GOOGLE_ADS_ID;

  useEffect(() => {
    if (metaId && !window.fbq) {
      const init = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${metaId}');fbq('track','PageView');`;
      const s = document.createElement("script");
      s.innerHTML = init;
      document.head.appendChild(s);
    }

    if (googleId && !window.gtag) {
      const ext = document.createElement("script");
      ext.async = true;
      ext.src = `https://www.googletagmanager.com/gtag/js?id=${googleId}`;
      document.head.appendChild(ext);
      const inline = document.createElement("script");
      inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${googleId}');`;
      document.head.appendChild(inline);
    }

    // Helper for custom conversions
    window.bcTrack = (event, params = {}) => {
      try {
        if (window.fbq) window.fbq("track", event, params);
        if (window.gtag) window.gtag("event", event, params);
        // eslint-disable-next-line no-console
        console.log("[bcTrack]", event, params);
      } catch (e) {
        // swallow
      }
    };
  }, [metaId, googleId]);

  return null;
}
